/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Dashboard_Reorder_HandleInputs */



/**
* | output |
* | --- |
* | "Move this card (position {position})" |
*
* @param {Dashboard_Reorder_HandleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_reorder_handle = /** @type {((inputs: Dashboard_Reorder_HandleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Reorder_HandleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese Karte verschieben (Position ${i?.position})`)
	return /** @type {LocalizedString} */ (`Move this card (position ${i?.position})`)
});